import { mockUsers, currentUser, mockApiResponse } from '../mock-data';
import type { User } from '../mock-data';

// Stub API for authentication
export const authApi = {
  login: async (username: string, password: string) => {
    // Restricted authentication - only allow specific credentials
    if (username === 'admin@blackbook.com' && password === 'BB2025!Dev#Suite') {
      
      // Create authorized user profile
      const user: User = {
        id: 'admin-001',
        username: 'admin@blackbook.com',
        email: 'admin@blackbook.com',
        firstName: 'System',
        lastName: 'Administrator',
        company: 'Black Book Network',
        subscriptions: ['usedCar', 'newCar', 'truck', 'powerSports', 'rv', 'cpi', 'residuals'] as const,
        preferences: {
          defaultProduct: 'usedCar' as const,
          region: 'National',
          theme: 'light' as const
        }
      };
      
      return mockApiResponse({
        user,
        token: 'mock-jwt-token-' + Date.now(),
        refreshToken: 'mock-refresh-token',
        expiresIn: 3600
      });
    }
    
    throw new Error('Invalid credentials');
  },

  getCurrentUser: async (): Promise<User> => {
    return currentUser;
  },

  logout: async () => {
    return mockApiResponse({ success: true });
  },

  refreshToken: async (refreshToken: string) => {
    return mockApiResponse({
      token: 'mock-jwt-token-' + Date.now(),
      expiresIn: 3600
    });
  }
};